import { Button } from 'src/components/UI/Button';
import { Flex } from 'src/components/UI/Flex';

interface StyledTabProps {
  children: React.ReactNode;
  onClick(): void;
  isSelected: boolean;
}

export const TabHeaderButton = (props: StyledTabProps) => {
  return (
    <Button
      p={'5px'}
      mr={'0px'}
      borderRadius={'20px'}
      _selected={{
        backgroundColor: 'secondary.400',
        boxShadow: '10px 10px 30px rgba(61, 14, 107, 0.15)',
      }}
      backgroundColor={props.isSelected ? 'secondary.400' : 'surface'}
      color={'primary.1000'}
      textTransform={'uppercase'}
      _focus={{
        boxShadow: 'none',
      }}
      onClick={props.onClick}
      h={'auto'}
      _hover={{}}
      w={'100%'}
    >
      <Flex>{props.children}</Flex>
    </Button>
  );
};
